import { formatDate } from "@clipboard-health/date-time";
import { Illustration, Text } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { formatValidityPeriod, getMinimumTestDate } from "../constants";
import { type TbTestType } from "../types";

interface InvalidTestErrorStepProps {
  requirementId: string;
  testType: TbTestType;
  onReset: () => void;
}

export function InvalidTestErrorStep(props: InvalidTestErrorStepProps) {
  const { requirementId, testType, onReset } = props;

  useLogEffect(APP_V2_USER_EVENTS.VIEWED_TB_TEST_GUIDED_UPLOAD_INVALID_TEST_ERROR_STEP, {
    requirementId,
    testType,
  });

  const formattedMinimumDate = formatDate(getMinimumTestDate(testType));

  return (
    <>
      <DialogContent>
        <Stack spacing={6} sx={{ alignItems: "center", textAlign: "center", paddingTop: 8 }}>
          <Illustration type="document-rejected" />

          <Text variant="h3">Your TB test is invalid</Text>

          <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            Clipboard requires a TB test to be done within the last {formatValidityPeriod(testType)}
            . Upload one dated after {formattedMinimumDate}.
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="vertical">
        <Button fullWidth size="large" variant="contained" onClick={onReset}>
          Update TB test
        </Button>
      </DialogFooter>
    </>
  );
}
